import React from 'react';
import { Nav } from 'react-bootstrap';


const Footer = () => (
  <footer className="d-flex mt-3 position-absolute left-0 bottom-0 w-100 flex-wrap justify-content-between text-sm-center align-items-center py-2 px-3 border-top bg-light">
    <div className="text-body-secondary">
      <p className='m-0'>© 2017 - 2025 <a href='https://www.doltlabs.in' target='_blank' className='fw-bold link-secondary text-decoration-none' rel="noreferrer">Dolt Labs</a> - A Dolt Enterprise Company, India</p>
    </div>

    <div>
      <Nav className="justify-content-center">
        <Nav.Link href="/contact" className="pe-2 text-body-secondary">Support</Nav.Link>
        <Nav.Link href="/privacy" className="px-2 text-body-secondary">Privacy</Nav.Link>
        <Nav.Link href="/license" className="px-2 text-body-secondary">Licenses</Nav.Link>
      </Nav>
    </div>
  </footer>

);

export default Footer;
